<template>
  <v-dialog
    v-model="dialog"
    v-if="ativo"
    width="auto"
    persistent
    class="dialog-blur"
  >
    <div
      class="bg-white onest-font max-w-[90vw] w-[35vw] md:w-[30vw] min-h-[40vh] h-auto p-8 rounded-3xl flex flex-col justify-between shadow-2xl mx-auto"
    >
      <div>
        <h2 class="font-bold text-4xl text-gray-800">Enviar Convite</h2>
      </div>

      <div class="flex-1 flex flex-col mt-6">
        <p class="mb-2 font-semibold">
          Preencha os dados do testador para convidá-lo:
        </p>

        <div class="flex flex-col gap-4 mt-2">
          <v-text-field
            v-model="formulario.nome"
            label="Nome do usuário"
            placeholder="Ex: João da Silva"
            variant="solo"
            flat
            hide-details
            class="custom-input"
          ></v-text-field>

          <v-text-field
            v-model="formulario.email"
            label="Email do usuário"
            placeholder="Ex: joao@exemplo.com"
            type="email"
            variant="solo"
            flat
            hide-details
            class="custom-input"
          ></v-text-field>
        </div>

        <!-- SELEÇÃO DE PAPÉIS (ATORES) -->
        <div class="mt-6 flex-1 flex flex-col">
          <p class="font-bold text-sm text-gray-700 mb-2">
            Papéis a serem testados:
          </p>
          <div v-if="loadingAtores" class="flex justify-center my-4">
            <v-progress-circular
              indeterminate
              color="primary"
              size="24"
            ></v-progress-circular>
          </div>
          <div
            v-else-if="atores.length === 0"
            class="text-sm text-gray-500 italic my-2"
          >
            Nenhum papel cadastrado neste projeto.
          </div>
          <div
            v-else
            class="flex flex-col gap-1 max-h-[160px] overflow-y-auto pr-2 custom-scrollbar border border-gray-100 rounded-xl p-2 bg-gray-50/50"
          >
            <v-checkbox
              v-for="ator in atores"
              :key="ator.id_ator"
              v-model="atoresSelecionados"
              :value="ator.id_ator"
              :label="ator.nome_ator"
              density="compact"
              hide-details
              color="primary"
              class="custom-checkbox"
            ></v-checkbox>
          </div>
        </div>

        <div class="flex justify-end gap-3 mt-8 pt-4 border-t border-gray-100">
          <v-btn
            @click="cancelar"
            variant="outlined"
            height="auto"
            color="primary"
            class="!px-6 !py-2.5 !font-bold !rounded-xl !transition-colors !normal-case tracking-normal"
            prepend-icon="mdi-close-circle-outline"
          >
            Cancelar
          </v-btn>
          <v-btn
            @click="enviar"
            variant="flat"
            height="auto"
            color="primary"
            class="!px-6 !py-2.5 !text-white !font-bold !rounded-xl !transition-colors !normal-case tracking-normal shadow"
            prepend-icon="mdi-email-fast"
          >
            Enviar
          </v-btn>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';

/**
 * @module ModalSendInvite
 * @desc Modal para enviar convite a um novo testador com múltiplos papéis.
 */
export default {
  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
    idProjeto: {
      type: [Number, String],
      required: true,
    },
  },
  emits: ['update:ativo', 'enviar-convite'],
  computed: {
    dialog: {
      get() {
        return this.ativo;
      },
      set(value) {
        this.$emit('update:ativo', value);
      },
    },
  },
  data: () => ({
    formulario: {
      nome: '',
      email: '',
    },
    atores: [],
    atoresSelecionados: [],
    loadingAtores: false,
  }),
  watch: {
    ativo(val) {
      if (val) {
        this.carregarAtores();
      }
    },
  },
  methods: {
    /**
     * Busca os atores associados ao projeto
     */
    async carregarAtores() {
      if (!this.idProjeto) {
        return;
      }
      this.loadingAtores = true;
      try {
        const res = await axios.get(
          `${apiUrl}/api/v1/ator/projeto/${this.idProjeto}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.atores = res.data.ator || [];
        this.atoresSelecionados = [];
      } catch (error) {
        console.error('Erro ao carregar atores:', error);
        this.$toast.error('Erro ao carregar os papéis do projeto.');
      } finally {
        this.loadingAtores = false;
      }
    },
    /**
     * Cancela o envio do convite, resetando o formulário e fechando o modal.
     */
    cancelar() {
      this.formulario = { nome: '', email: '' };
      this.atoresSelecionados = [];
      this.dialog = false;
    },
    /**
     * Envia o convite ao testador, validando os dados e emitindo o evento.
     */
    enviar() {
      if (!this.formulario.nome || !this.formulario.email) {
        this.$toast.warning(
          'Por favor, preencha o nome e o e-mail do testador.',
        );

        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.formulario.email)) {
        this.$toast.warning('Por favor, insira um e-mail válido.');

        return;
      }

      if (this.atoresSelecionados.length === 0) {
        this.$toast.warning('Selecione ao menos um papel para o testador.');

        return;
      }

      this.$emit('enviar-convite', {
        ...this.formulario,
        idAtores: this.atoresSelecionados,
      });
      this.formulario = { nome: '', email: '' };
      this.atoresSelecionados = [];
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.onest-font {
  font-family: 'Onest', sans-serif !important;
}

:deep(.v-overlay__scrim) {
  backdrop-filter: blur(5px) !important;
  -webkit-backdrop-filter: blur(5px) !important;
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.3) !important;
}

.custom-input:deep(.v-field) {
  @apply !bg-gray-100 !border-2 !border-gray-100 !rounded-xl !shadow-none;
}
.custom-input:deep(.v-field--focused) {
  @apply !border-blue-500 !bg-white;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 3px;
}

.custom-checkbox:deep(.v-label) {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #374151 !important;
}
</style>
